// Load framework & 3rd party libs

import Vue from 'vue'
import App from '@/core/App'
import router from '@/router'

// Load global custom components

import FormContainer from '@/components/common/FormContainer'
import LoadingIndicator from '@/components/common/LoadingIndicator'
import RequiringUser from '@/components/common/RequiringUser'
import MainMenu from '@/components/MainMenu'

// Load plugins and setup & initialization helpers

import { setupStore } from '@/store'
import { setupI18n, updateI18nLanguage } from '@/i18n'
import setupBootstrap from '@/core/setup-bootstrap'
import setupIcons from '@/core/setup-icons'
import setupParse from '@/core/setup-parse'
import { setupValidation, updateValidationLanguage } from '@/core/setup-validation'
import initializeStore from '@/core/initialize-store'

// Register global custom components

Vue.component('form-container', FormContainer)
Vue.component('loading-indicator', LoadingIndicator)
Vue.component('requiring-user', RequiringUser)
Vue.component('main-menu', MainMenu)

// Configure Vue

Vue.config.productionTip = false

const store = setupStore(Vue)
const i18n = setupI18n(Vue, 'en')
setupBootstrap(Vue)
setupIcons(Vue)
setupParse()
setupValidation(Vue, 'en')

// Initialize store

store.watch(state => {
  return state.ui.language
}, newLanguage => {
  updateI18nLanguage(newLanguage)
  updateValidationLanguage(newLanguage)
})

// Will cause all language-dependent subsystems to get updated via store change
// watched by the above code
initializeStore(store)

// Setup route guards

router.beforeEach((to, from, next) => {
  const isAppEmbedded = to.query['app-embedded'] === 'true'
  store.commit('setIsAppEmbedded', isAppEmbedded)
  next()
})

// Create app

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/core/main.js